import TableMain from 'v2/components/Tables/TableMain';
import Box from 'v2/components/UI/Box';
import useUsers from './hooks/useUsers';
import Text from 'v2/components/UI/Text';
import HashLoading from 'v2/components/UI/Loading/Hash';

const Users: React.FC = () => {
  const {
    data,
    valueInputSearch,
    isLoading,
    onChangeInputSearch,
    handleClickOption,
    handleNavigateCreateUser,
  } = useUsers();

  const renderStatus = (isActive: boolean) => {
    if (isActive) {
      return (
        <Box
          width={'100%'}
          maxWidth={100}
          borderRadius={8}
          backgroundColor={'#00b74920'}
          alignItems="center"
          justifyContent="center"
          padding={'5px 10px'}
        >
          <Text color="#30BF9B" fontWeight={600}>
            Ativo
          </Text>
        </Box>
      );
    }
    return (
      <Box
        width={'100%'}
        maxWidth={100}
        borderRadius={8}
        backgroundColor={'#F4A61E20'}
        alignItems="center"
        justifyContent="center"
        padding={'5px 10px'}
      >
        <Text color="#F4A61E" fontWeight={600}>
          Inativo
        </Text>
      </Box>
    );
  };

  const bodyOptions = data?.map((item) => {
    const arr = item.map((itemArr) => {
      if (typeof itemArr === 'boolean') {
        return renderStatus(itemArr);
      }
      return itemArr;
    });

    return [...arr];
  });

  const renderTableOrLoading = () => {
    if (isLoading) {
      return (
        <Box
          width={'100%'}
          height={'100%'}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <HashLoading size={55} />
        </Box>
      );
    }
    return (
      <TableMain
        title="Usuários"
        titleButtonCta="Novo usuário"
        nameIconButtonCta="AddOutlined"
        titleButtonSearch="Pesquisar usuário"
        isActiveDownload
        headerOptions={[
          'Nome/Razão social',
          'Email',
          'Celular',
          'CPF/CNPJ',
          'Status',
        ]}
        bodyOptions={bodyOptions || []}
        handleClickOption={handleClickOption}
        onChangeInputSearch={onChangeInputSearch}
        valueInputSearch={valueInputSearch}
        handleClickButtonCtaHeader={handleNavigateCreateUser}
      />
    );
  };
  return <Box padding={'30px 20px'}>{renderTableOrLoading()}</Box>;
};
export default Users;
